
import { Badge, Col, Row } from "react-bootstrap";

const toMatrix = (arr, width) =>
  arr.reduce((rows, key, index) => (index % width == 0 ? rows.push([key])
    : rows[rows.length - 1].push(key)) && rows, []);

const getHighlights = (item) => {
  let arrHL = [];
  if (item.company_highligh1) { arrHL.push(item.company_highligh1); }
  if (item.company_highligh2) { arrHL.push(item.company_highligh2); }
  if (item.company_highligh3) { arrHL.push(item.company_highligh3); }
  return arrHL;
};

const CompanyOverview = (data) => {
  const item = data.data.company;
  const locations = data.data.locations || [];
  const hqLocation = locations.find(loc => loc.headquarters) || locations[0];
  const clients = data.data.company.company_clients || [];


  return (
    <div id="overview" className="text-block">
      <h2 className="h4 mb-3">Overview</h2>
      <Col>
        <Row>
          <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
            <div className="label-heading">Company size</div>
            <p className="text-sm fw-bold">
              {item.company_size.label}
            </p>
            <div className="label-heading">Founded</div>
            <p className="text-sm fw-bold mb-0">
              {item.company_founded}
            </p>
          </Col>
          <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
            <div className="label-heading">Hourly rate</div>
            <p className="text-sm fw-bold">
              {item.company_hourly_rate.label}
            </p>
            <div className="label-heading">Minimal project</div>
            <p className="text-sm fw-bold mb-0">
              {item.company_project_minimal_size.label}
            </p>
          </Col>
          <Col xs="6" md="4" lg="3" className="py-3 mb-3 mb-lg-0">
            <div className="label-heading">Headquarters</div>
            <p className="text-sm fw-bold">
              {hqLocation
                ? `${hqLocation.location_city}, ${hqLocation.location_country?.value}`
                : 'Not available'
              }
            </p>
            <div className="label-heading">Ready to start</div>
            <p className="text-sm fw-bold mb-0">
              {item.company_start_time.label}
            </p>
          </Col>
        </Row>
        {getHighlights(item).length > 0 && (
          <Row>
            <Col className="pt-3 mb-3 mb-lg-0">
              <div className="label-heading">Highlights</div>
              {getHighlights(item).map((highligh, index) => (
                <Row key={index}>
                  <Col>
                    <Badge
                      key={index}
                      text="dark"
                      className="p-2 mb-2 bg-light-gray text-wrap"
                    >
                      {highligh}
                    </Badge>
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        )}
        {(clients.length > 0) &&
          <Row>
            <Col md="12" lg="12" className="pt-3 mb-3 mb-lg-0">
              <div className="label-heading">Key clients</div>
            </Col>
          </Row>
        }
        {toMatrix(clients, 4).map((client, index) => (
          <Row key={index}>
            {client.map((subclient, subindex) =>
              <Col key={subindex} xs="6" md="4" lg="3" className="py-0 mb-3 mb-lg-0 ">
                <Badge
                  text="dark secondary text-uppercase text-wrap"
                  className="d-flex flex-column mb-2 px-1 lg-0 bg-light-gray"
                >{typeof subclient === 'object' && subclient !== null ? subclient.label : subclient}
                </Badge>
              </Col>
            )}
          </Row>
        ))}
      </Col>
    </div>
  );
}

export default CompanyOverview